import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';
import { ObjetMaquette } from '../objet-maquette.model';
import { ObjetMaquetteUndoCommand } from './command';
import { CommandEvents } from './command-events';

export class DeclarerPointInscriptionAdministrativeCommand extends ObjetMaquetteUndoCommand<ObjetMaquette> {
    constructor(
        codeStructure: string,
        id: string,
        version: string,
        events: CommandEvents,
        objetMaquetteService: ObjetMaquetteService,
        private contexteId: string,
        private ignoreConflict: boolean
    ) {
        super(codeStructure, id, version, events, objetMaquetteService);
    }

    do(): Observable<ObjetMaquette> {
        return this.objetMaquetteService
            .declarerPointInscriptionAdministrative(this.id, this.contexteId, this.version)
            .pipe(tap(om => this.events.objetMaquetteModifie$.next(om)));
    }

    undo(): Observable<ObjetMaquette> {
        return this.objetMaquetteService
            .retirerPointInscriptionAdministrative(this.id, this.contexteId, this.version, this.ignoreConflict)
            .pipe(tap(om => this.events.objetMaquetteModifie$.next(om)));
    }
}
